import React, { useCallback, useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { ThunkGetClientPortalTechnicianData } from '../../../store/config/thunks';
import { PortalTechnicianDataSelector } from '../../../store/config/selectors';

import { ReactComponent as HelpIcon } from '../../../assets/help.icon.svg';
import TechnicianDataDialog from '../dialogs/TechnicanDataDialog';

const TechnicianData: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [openTechnicianDataDialog, setOpenTechnicianDataDialog] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const techData = useAppSelector(PortalTechnicianDataSelector);

  const onMount = useCallback(() => {
    setLoading(true);
    dispatch(ThunkGetClientPortalTechnicianData())
      .unwrap()
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch]);

  useEffect(() => {
    onMount();
  }, [onMount]);

  return (
    <>
      {Object.values(techData).some(i => !!i) && (
        <HelpIcon
          onClick={() => {
            setOpenTechnicianDataDialog(true);
          }}
        />
      )}

      {!loading && (
        <TechnicianDataDialog
          open={openTechnicianDataDialog}
          onClose={() => {
            setOpenTechnicianDataDialog(false);
          }}
        />
      )}
    </>
  );
};

export default TechnicianData;
